import { Component } from '@angular/core';

@Component({
  selector: 'app-consumption-pallet-empty',
  templateUrl: './consumption-pallet-empty.component.html',
  styleUrls: ['./consumption-pallet-empty.component.scss']
})
export class ConsumptionPalletEmptyComponent {}
